import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgEventFilled = (props, ref) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M7.5 2.25C7.91421 2.25 8.25 2.58579 8.25 3V3.75H15.75V3C15.75 2.58579 16.0858 2.25 16.5 2.25C16.9142 2.25 17.25 2.58579 17.25 3V3.75H18C20.0711 3.75 21.75 5.42893 21.75 7.5V18C21.75 20.0711 20.0711 21.75 18 21.75H6C3.92893 21.75 2.25 20.0711 2.25 18V7.5C2.25 5.42893 3.92893 3.75 6 3.75H6.75V3C6.75 2.58579 7.08579 2.25 7.5 2.25ZM12 9.45831L13.0942 11.7897L15.5417 12.1659L13.7709 13.9795L14.1888 16.5416L12 15.3314L9.81129 16.5416L10.2292 13.9795L8.45837 12.1659L10.9055 11.7897L12 9.45831Z",
		fill: "#111827"
	})
});
const ForwardRef = forwardRef(SvgEventFilled);
export default ForwardRef;
